// URL utility for generating consistent product and category URLs

// Cache for dynamic category data from API
let cachedSarrafiyeSlugs = null;
let cachedTakiSlugs = null;

/**
 * Set category slugs dynamically from API response
 * Call this when categories are loaded from the backend
 */
export const setCategorySlugs = (sarrafiyeCats = [], takiCats = []) => {
    cachedSarrafiyeSlugs = sarrafiyeCats.map(c => c.slug);
    cachedTakiSlugs = takiCats.map(c => c.slug);
};

/**
 * Get sarrafiye family slugs (dynamic or fallback to static)
 */
export const getSarrafiyeFamilySlugs = () => {
    return cachedSarrafiyeSlugs || ['gram-kulce-altin', 'gram-kulce-gumus', 'ziynet-altin', 'carmen'];
};

/**
 * Get taki family slugs (dynamic or fallback to static)
 * Only main categories, not subcategories
 */
export const getTakiFamilySlugs = () => {
    return cachedTakiSlugs || [
        '14-ayar',
        '22-ayar',
        'altin-kolye',
        'altin-bilezik',
        'altin-yuzuk',
        'altin-kupe',
        'altin-bileklik',
        'altin-set'
    ];
};

/**
 * Generate URL for a product page
 * Sarrafiye family: /sarrafiye/gram-kulce-altin/product-slug
 * Taki: /taki-ve-mucevherat/product-slug
 * Others: /urun/product-slug (fallback)
 */
export const getProductUrl = (product) => {
    if (!product) return '/';
    return `/urun/${product.slug}`;
};

/**
 * Generate URL for a category page
 * Sarrafiye family: /sarrafiye/category-slug/sub-slug
 * Taki: /taki-ve-mucevherat/category-slug/sub-slug
 * Others: /kategori/category-slug/sub-slug
 */
export const getCategoryUrl = (categorySlug, subcategorySlug = null) => {
    let baseUrl = '';
    
    const sarrafiyeFamily = getSarrafiyeFamilySlugs();
    const takiFamily = getTakiFamilySlugs();

    if (categorySlug === 'sarrafiye') {
        baseUrl = '/sarrafiye';
    } else if (sarrafiyeFamily.includes(categorySlug)) {
        baseUrl = `/sarrafiye/${categorySlug}`;
    } else if (categorySlug === 'taki-ve-mucevherat') {
        baseUrl = '/taki-ve-mucevherat';
    } else if (takiFamily.includes(categorySlug)) {
        baseUrl = `/taki-ve-mucevherat/${categorySlug}`;
    } else {
        baseUrl = `/kategori/${categorySlug}`;
    }

    if (subcategorySlug) {
        return `${baseUrl}/${subcategorySlug}`;
    }

    return baseUrl;
};
